import { useMemo } from 'react'

import {
  nextExecution,
  isWithinWindow
} from 'components/schedules/trigger-utils'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'
import { naturalSortBy } from 'utils/list'

export default function useScheduleResource({
  interval,
  shouldCache = true,
  enabled = true
}) {
  const { currentTeamId, isPaywallActive } = useAuth()

  const isEnabled = enabled && !isPaywallActive

  const { data: scheduledAttacks } = useAgent(
    `/schedules/active?teamId=${currentTeamId}`,
    [],
    {
      interval,
      shouldCache,
      skipRequest: !isEnabled
    }
  )

  const { data: scheduledScenarios } = useAgent(
    `/schedules/scenarios?teamId=${currentTeamId}`,
    [],
    {
      interval,
      shouldCache,
      skipRequest: !isEnabled
    }
  )

  const schedules = useMemo(() => {
    const schedules = [...scheduledAttacks, ...scheduledScenarios]
    const sortedSchedules = naturalSortBy(schedules, (schedule) => {
      if (isWithinWindow(schedule.trigger)) {
        return new Date().toISOString()
      }
      return nextExecution(schedule.trigger)
    })

    return { schedules: sortedSchedules }
  }, [scheduledAttacks, scheduledScenarios])

  return schedules
}
